import {EditGuesser, FieldGuesser, InputGuesser, ListGuesser, ShowGuesser} from "@api-platform/admin";
import {
  List,
  Datagrid,
  DateField,
  DateInput,
  ReferenceManyField,
  ReferenceManyCount,
  TextField,
  BooleanField,
  ArrayField,
  EmailField,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  SelectArrayInput,
  Show,
  TabbedShowLayout,
  Admin,
  Resource,
  useEditContext,
  useShowContext,
  useRecordContext,
  TabbedForm,
  EditButton,
  ReferenceField,
  SingleFieldList,
  FunctionField,
  ChipField,
  Button,
  SelectInput,
  TopToolbar,
  DatagridConfigurable,
  SelectColumnsButton,
  FilterButton,
  CreateButton,
  ExportButton,
  ReferenceInput,
  AutocompleteInput,
  ShowButton,
  useNotify,
  useRefresh,
  SimpleShowLayout,
} from "react-admin";
import { ENTRYPOINT } from "../config";
import { fetchHydra } from "../utils/dataProviderHydra";
import { Link } from "react-router-dom";

const UtilisateurDemandeListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const RenewInvitationButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record || (record.type !== "invitation" && record.type !== "reinvitation")) {
    return null;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    if (!window.confirm("Voulez-vous vraiment renvoyer l'invitation ?")) {
      return;
    }

    const url = new URL(`${ENTRYPOINT}/opened/renew_invitation`);
    const body = {
      identifiant: record.data,
    };

    // faire un check de la requete car il cree une deuxieme demande que je le fait !!!!!!!!!!
    fetchHydra(url, { method: "POST", body: JSON.stringify(body) })
      .then(() => {
        notify("Invitation renvoyée avec succès", { type: "success" });
        refresh();
      })
      .catch((e) => {
        notify(`Erreur: ${e.message}`, { type: "error" });
      });
  };

  return <Button label="Réinviter" onClick={handleClick}/>;
};

const UtilisateurDemandeShowActions = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);

const types = [
    { id: 'changement_email', name: 'Changement Email' },
    { id: 'changement_telephone', name: 'Changement téléphone' },
    { id: 'invitation', name: 'Invitation' },
    { id: 'reinvitation', name: 'Réinvitation' },
    { id: 'reinitialisation_motpasse', name: 'Réinit Mot de passe' },
];

const utilisateurDemandeFilters = [
    <ReferenceInput source="utilisateur_id" reference="utilisateurs" name={"Utilisateur"}>
    <AutocompleteInput
      optionText={(choice) =>
        choice?.id // the empty choice is { id: '' }
          ? `${choice.name}`
                    : ''
      }
            name={"utilisateur"}/>
  </ReferenceInput>,
  <SelectInput source="type" name={"type"} field={"type"} choices={types} />,
  <TextInput source="data" label="Data" />,
];

export const UtilisateurDemandeList = props => (
    <List {...props} filters={utilisateurDemandeFilters} actions={<UtilisateurDemandeListActions />}>
    <DatagridConfigurable rowClick={"edit"}>
            <ReferenceField reference="utilisateurs" source="utilisateur" label="Utilisateur">
        <TextField source="name" />
      </ReferenceField>
      <FieldGuesser source={"code"} />
      <FieldGuesser source={"date"} />
      <FieldGuesser source={"dateValidite"} />
      <FieldGuesser source={"nombreTentative"} />
      <FieldGuesser source={"type"} />
      <FieldGuesser source={"data"} />
            <FieldGuesser source={"succes"} label="Demande réussie"/>
            <FieldGuesser source={"updatedAt"} label="Date dernière modification"/>
      <RenewInvitationButton />
      <ShowButton />
      <EditButton />
    </DatagridConfigurable>
  </List>
);

export const UtilisateurDemandeShow = (props) => (
  <Show actions={<UtilisateurDemandeShowActions />} {...props}>
    <SimpleShowLayout>
      <ReferenceField
        reference="utilisateurs"
        source="utilisateur"
        label="Utilisateur"
      >
        <TextField source="name" />
      </ReferenceField>
      <FieldGuesser source={"code"} />
      <FieldGuesser source={"date"} />
      <FieldGuesser source={"dateValidite"} />
      <FieldGuesser source={"nombreTentative"} />
      <FieldGuesser source={"type"} />
      <FieldGuesser source={"data"} />
      <FieldGuesser source={"succes"} label="Demande réussie" />
      <FieldGuesser source={"updatedAt"} label="Date dernière modification" />
    </SimpleShowLayout>
  </Show>
);

export const UtilisateurDemandeEdit = props => (
  <EditGuesser {...props}>
    <RenewInvitationButton />
    <p> Utilisateur: <br></br> <FieldGuesser source={"utilisateur"} /></p>
    <InputGuesser source={"code"} />
    <InputGuesser source={"date"} />
    <InputGuesser source={"dateValidite"} />
    <InputGuesser source={"nombreTentative"} />
    <p>Type de demande: <br></br> <FieldGuesser source={"type"} /></p>
    <InputGuesser source={"data"} label={"Données"} />
    <InputGuesser source={"succes"} label={"Demande réussie"} />
  </EditGuesser>
);

